export const IRESS_GOOGLE_PLAYSTORE = 'https://play.google.com/store/apps/details?id=com.iress&gl=SG';
export const IRESS_APPLE_STORE = 'https://apps.apple.com/sg/app/iress/id473163812';

export const W8_ALLOWED_DECLARATION_AFTER = 24;
